function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useContext, useImperativeHandle, forwardRef } from 'react';
import { observer } from 'mobx-react';
import './../../scss/common/loader.scss';
import { CMSContext } from '../neurosales/CMSContextProvider';
import ProgressBar from './ProgressBar';
const ProgressBarRef = observer( /*#__PURE__*/forwardRef((props, ref) => {
  const cmsContext = useContext(CMSContext);
  const [progress, setProgress] = useState(-1);

  // per usarlo come riferimento
  useImperativeHandle(ref, () => ({
    setProgress: value => {
      const oldValue = progress;
      setProgress(value);
      if (value === -1 && oldValue !== -1) {
        cmsContext.decreaseLoaders();
      } else if (oldValue === -1 && value !== -1) {
        cmsContext.increaseLoaders();
      }
    }
  }));
  return /*#__PURE__*/React.createElement(ProgressBar, _extends({}, props, {
    show: progress !== -1,
    progress: progress
  }));
}));
export default ProgressBarRef;